import { render, staticRenderFns } from "./selectMapGoodsModal.vue?vue&type=template&id=95a740d2&scoped=true&"
import script from "./selectMapGoodsModal.vue?vue&type=script&lang=js&"
export * from "./selectMapGoodsModal.vue?vue&type=script&lang=js&"
import style0 from "./selectMapGoodsModal.vue?vue&type=style&index=0&id=95a740d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a740d2",
  null
  
)

export default component.exports